export enum AmplitudeTrackingEventPropValues {
    CAMERA_STATUS_CAMERA_OFF = 'Camera Off',
    CAMERA_STATUS_CAMERA_ON = 'Camera On',
    FEEDBACK_THUMBS_DOWN = 'Thumbs Down',
    FEEDBACK_THUMBS_UP = 'Thumbs Up',
    MUTE_STATUS_MUTED = 'Muted',
    MUTE_STATUS_UNMUTED = 'Unmuted',
}
